import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledGrowCell = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'stretch',
}))`
  background-color: var(--whiteCaniche);
  flex: 1;
  border-left: 1px solid var(--greyMouse);
  height: 100%;
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    width: 10px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2));
  }
`;

export default StyledGrowCell;
